import { Button, Container, Grid, Typography } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import axios from "axios";
import React, { Component } from "react";
import { Route, Routes } from "react-router";
import { Link, NavLink } from "react-router-dom";
import { API } from "../Constants/APIs";
import init from "../Helpers/Windotoken";
import AllProducts from "./AllProducts";
import DraftProducts from "./DraftProducts";
import LiveProducts from "./LiveProducts";
import PendingProducts from "./PendingProducts";
import WIPproducts from "./WIPproducts";

export default class ProductList extends Component {
  state = {
    products0: [],
    categories: [],
    expandMore: false,
    expand: 0,
    scrollIndex: 1,
    pageCount: 1,
    hasNextPage: true,
    page: 1,
    totalpage: 1,
    metaData: {},
    selected: 0,
    showSearchSuggestions: false,
    productStatus: "",
    query: "",
    perPage: "8",
    searching: false,
    userdetail: {},
  };
  componentDidMount() {
    this.getMetaData();
    this.fetchCategories();
    this.getUser();
  }
  fetchCategories = () => {
    this.setState({ loading: true });
    if (init() === "success") {
      axios
        .get(
          API.getUrls.getUserCat +
            "?status=" +
            this.state.productStatus +
            "&q=" +
            this.state.query
        )
        .then((res) => {
          // console.log(res);
          this.setState({
            categories: res.data.categories,
            CategoryLength: res.data.categories.length === 0 ? true : false,
            loading: false,
          });
        });
    }
  };
  serachProducts = (e) => {
    this.setState({ searching: true, visible: true, showAll: false });
    if (e.target.value.length > 3) {
      this.setState(
        {
          query: e.target.value,
          showSearchSuggestions: true,
        },
        () => {
          this.fetchCategories();
        }
      );
    } else if (e.target.value.length === 0) {
      this.setState(
        {
          searching: false,
          query: "",
        },
        () => {
          this.fetchCategories();
        }
      );
    }
  };

  getMetaData = () => {
    if (init() === "success") {
      axios.get(API.getUrls.productMeta).then((res) => {
        this.setState({ metaData: res.data });
      });
    }
  };
  getUser = () => {
    this.setState({ loader: true });
    if (init() === "success") {
      axios.get(API.getUrls.getUser).then((res) => {
        this.setState({ userdetail: res.data.user, loader: false });
      });
    }
  };

  logout = () => {
    localStorage.clear();
    window.location.href = "/sign-in";
  };
  render() {
    return (
      <Container className="containerSpacingdashBoard" maxWidth={"lg"}>
        <Grid container spacing={2} className="userDashboard">
          <Grid item sm={2} className="sidebar">
            {/* <Sidebar /> */}
            <div className="">
              {this.state.userdetail ? (
                this.state.userdetail.company_logo ? (
                  <img
                    src={API.imgUrl + this.state.userdetail.company_logo}
                    style={{
                      width: "123px",
                      height: "123px",
                      borderRadius: "16px",
                    }}
                    alt=""
                  />
                ) : (
                  <div className="sidebarItem"> </div>
                )
              ) : (
                <div className="sidebarItem"> </div>
              )}

              {this.state.userdetail ? (
                <Typography className="nameComp" align={"center"}>
                  {this.state.userdetail
                    ? this.state.userdetail.company_name === "undefined"
                      ? "Company Name"
                      : this.state.userdetail.company_name
                      ? this.state.userdetail.company_name
                      : null
                    : null}
                </Typography>
              ) : (
                <Typography className="nameComp" align={"center"}>
                  {"Company Name"}
                </Typography>
              )}

              <Typography className="performance"> Performance </Typography>
              <Grid container spacing={2} style={{ textAlign: "left" }}>
                <Grid item sm={6}>
                  <span className="spanTag">Total Views</span>
                </Grid>
                <Grid item sm={6} style={{ textAlign: "center" }}>
                  <span className="spanTag">
                    {this.state.metaData.totalViews
                      ? this.state.metaData.totalViews
                      : 0}
                  </span>
                </Grid>
              </Grid>

              <Typography className="performance"> Products </Typography>

              <Grid container spacing={2} style={{ textAlign: "left" }}>
                <Grid item sm={6}>
                  <NavLink
                    exact
                    to="/productlist/allProducts"
                    className="onHoverLink"
                  >
                    <span
                      className="spanTag"
                      onClick={() =>
                        this.setState({ productStatus: "All Products" }, () => {
                          this.fetchCategories();
                        })
                      }
                    >
                      All Products
                    </span>
                  </NavLink>
                </Grid>
                <Grid item sm={6} style={{ textAlign: "center" }}>
                  <span className="spanTag">
                    {this.state.metaData.all ? this.state.metaData.all : 0}
                  </span>
                </Grid>
              </Grid>

              <Grid container spacing={2} style={{ textAlign: "left" }}>
                <Grid item sm={6}>
                  <NavLink exact to="/productlist/live" className="onHoverLink">
                    <span
                      className="spanTag"
                      onClick={() =>
                        this.setState({ productStatus: "published" }, () => {
                          this.fetchCategories();
                        })
                      }
                    >
                      Live Products
                    </span>
                  </NavLink>
                </Grid>
                <Grid item sm={6} style={{ textAlign: "center" }}>
                  <span className="spanTag">
                    {" "}
                    {this.state.metaData.published
                      ? this.state.metaData.published
                      : 0}{" "}
                  </span>
                </Grid>
              </Grid>
              {/* <Grid container spacing={2} style={{ textAlign: "left" }}>
                <Grid item sm={6}>
                  <NavLink exact to="/productlist/wip" className="onHoverLink">
                    <span
                      className="spanTag"
                      onClick={() =>
                        this.setState({ productStatus: "WIP" }, () => {
                          this.fetchCategories();
                        })
                      }
                    >
                      WIP
                    </span>
                  </NavLink>
                </Grid>
                <Grid item sm={6} style={{ textAlign: "center" }}>
                  <span className="spanTag">
                    {this.state.metaData.wip ? this.state.metaData.wip : 0}
                  </span>
                </Grid>
              </Grid> */}

              {/* <Grid container spacing={2} style={{ textAlign: "left" }}>
                <Grid item sm={8}>
                  <NavLink
                    exact
                    to="/productlist/pending"
                    className="onHoverLink"
                  >
                    <span
                      className="spanTag"
                      onClick={() =>
                        this.setState({ productStatus: "pending" }, () => {
                          this.fetchCategories();
                        })
                      }
                    >
                      Awainting Approval
                    </span>
                  </NavLink>
                </Grid>
                <Grid item sm={4}>
                  <span className="spanTag" style={{ marginLeft: "5px" }}>
                    {" "}
                    {this.state.metaData.pending
                      ? this.state.metaData.pending
                      : 0}
                  </span>
                </Grid>
              </Grid> */}
              <Grid container spacing={2} style={{ textAlign: "left" }}>
                <Grid item sm={6}>
                  <NavLink
                    exact
                    to="/productlist/draft"
                    className="onHoverLink"
                  >
                    <span
                      className="spanTag"
                      onClick={() =>
                        this.setState(
                          {
                            productStatus: "draft",
                            categories: this.state.categories,
                          },
                          () => {
                            this.fetchCategories();
                          }
                        )
                      }
                    >
                      Draft Products
                    </span>
                  </NavLink>
                </Grid>
                <Grid item sm={6} style={{ textAlign: "center" }}>
                  <span className="spanTag">
                    {" "}
                    {this.state.metaData.drafted
                      ? this.state.metaData.drafted
                      : 0}{" "}
                  </span>
                </Grid>
              </Grid>
              <Link
                to="/product-create"
                style={{ textDecoration: "none", color: "#666666" }}
              >
                <Button
                  className="productBtn"
                  style={{
                    width: "100%",
                    fontSize: window.innerWidth < 1100 ? "14px" : "18px",
                    marginTop: "35px",
                  }}
                >
                  Add New Product +
                </Button>
              </Link>
              <Link
                to="/settings"
                style={{ textDecoration: "none", color: "#666666" }}
              >
                <Button
                  className="productBtn"
                  style={{
                    width: "100%",
                    fontSize: window.innerWidth < 1100 ? "14px" : "18px",

                    marginTop: "26px",
                  }}
                >
                  Settings
                </Button>
              </Link>
              <Button
                className="productBtn"
                onClick={this.logout}
                style={{
                  marginTop: "26px",
                  width: "100%",
                  fontSize: window.innerWidth < 1100 ? "14px" : "18px",
                }}
              >
                Logout
              </Button>
            </div>
          </Grid>
          <Grid item sm={10} className="productList">
            <div>
              <div className="flexWrapper">
                <NavLink
                  exact
                  to="/productlist/allProducts"
                  activeClassName="selectedLink bold"
                  style={{ textDecoration: "none", marginBottom: "12px" }}
                >
                  <Typography
                    className="rowheads"
                    onClick={() =>
                      this.setState({ productStatus: "" }, () => {
                        this.fetchCategories();
                      })
                    }
                    style={{
                      fontSize: window.innerWidth < 1100 ? "18px" : "18px",
                      fontWeight: "bold",
                      color: "#2D3436",
                    }}
                  >
                    All Products
                  </Typography>
                </NavLink>
                <NavLink
                  to="/productlist/draft"
                  className="active  "
                  activeClassName="selectedLink bold"
                  style={{ textDecoration: "none", marginBottom: "12px" }}
                >
                  <Typography
                    className="rowheads"
                    onClick={() =>
                      this.setState({ productStatus: "draft" }, () => {
                        this.fetchCategories();
                      })
                    }
                    style={{
                      fontSize: window.innerWidth < 1100 ? "18px" : "18px",
                    }}
                  >
                    Draft
                  </Typography>
                </NavLink>
                {/* <NavLink
                  to="/productlist/pending"
                  activeClassName="selectedLink bold"
                  style={{ textDecoration: "none", marginBottom: "12px" }}
                >
                  <Typography
                    className="rowheads"
                    onClick={() =>
                      this.setState({ productStatus: "pending" }, () => {
                        this.fetchCategories();
                      })
                    }
                    style={{
                      fontSize: window.innerWidth < 1100 ? "18px" : "18px",
                    }}
                  >
                    Pending
                  </Typography>
                </NavLink> */}
                <NavLink
                  to="/productlist/live"
                  activeClassName="selectedLink bold"
                  style={{ textDecoration: "none", marginBottom: "12px" }}
                >
                  <Typography
                    className="rowheads"
                    onClick={() =>
                      this.setState({ productStatus: "published" }, () => {
                        this.fetchCategories();
                      })
                    }
                    style={{
                      fontSize: window.innerWidth < 1100 ? "18px" : "18px",
                    }}
                  >
                    Live Products
                  </Typography>
                </NavLink>
                {/* <NavLink
                  to="/productlist/Wip"
                  activeClassName="selectedLink bold"
                  style={{ textDecoration: "none", marginBottom: "12px" }}
                >
                  <Typography
                    className="rowheads"
                    onClick={() =>
                      this.setState({ productStatus: "WIP" }, () => {
                        this.fetchCategories();
                      })
                    }
                    style={{
                      fontSize: window.innerWidth < 1100 ? "18px" : "18px",
                    }}
                  >
                    WIP
                  </Typography>
                </NavLink> */}
                <div style={{ position: "relative" }}>
                  <input
                    placeholder="Search Products"
                    name=""
                    onChange={this.serachProducts}
                    className="searchinput"
                    style={{
                      width: window.innerWidth < 1100 ? "270px" : "394px",
                      marginTop: "-12px",
                    }}
                  />
                  <SearchIcon className="serachIcon" />
                </div>
              </div>
              {this.state.searching ? (
                <div>
                  <p>{`Showing results for "` + this.state.query + `"`}</p>
                </div>
              ) : null}

              <Routes>
                <Route
                  path="allProducts"
                  element={
                    <AllProducts
                      categories={this.state.categories}
                      query={this.state.query}
                      productStatus={this.state.productStatus}
                      CategoryLength={this.state.CategoryLength}
                      loading={this.state.loading}
                      searching={this.state.searching}
                    />
                  }
                />
                <Route
                  path="draft"
                  element={
                    <DraftProducts
                      categories={this.state.categories}
                      query={this.state.query}
                      productStatus={this.state.productStatus}
                      CategoryLength={this.state.CategoryLength}
                      loading={this.state.loading}
                      searching={this.state.searching}
                    />
                  }
                />
                <Route
                  path="pending"
                  element={
                    <PendingProducts
                      categories={this.state.categories}
                      query={this.state.query}
                      productStatus={this.state.productStatus}
                      CategoryLength={this.state.CategoryLength}
                      loading={this.state.loading}
                    />
                  }
                />
                <Route
                  path="live"
                  element={
                    <LiveProducts
                      categories={this.state.categories}
                      query={this.state.query}
                      productStatus={this.state.productStatus}
                      CategoryLength={this.state.CategoryLength}
                      loading={this.state.loading}
                    />
                  }
                />
                <Route
                  path="Wip"
                  element={
                    <WIPproducts
                      categories={this.state.categories}
                      query={this.state.query}
                      productStatus={this.state.productStatus}
                      CategoryLength={this.state.CategoryLength}
                      loading={this.state.loading}
                    />
                  }
                />
              </Routes>

              {/* {this.state.showSearchSuggestions ? (
                <div>
                  {this.state.categories.map((singleCate, index) => (
                    <Accordion>
                      <AccordionSummary
                        aria-controls={"panel" + index + 1 + "a-content"}
                        id={"panel" + index + 1 + "a-header"}
                      >
                        <div className="CategoryDiv">
                          <Typography
                            className="Heading"
                            onClick={() => {
                              this.fetchModels(singleCate._id, index);
                            }}
                            key={index}
                          >
                            <span
                              style={{
                                marginRight: "30px",
                                marginLeft: "10px",
                              }}
                            >
                              {this.state.selected === index ? (
                                <RemoveIcon />
                              ) : (
                                <AddIcon />
                              )}
                            </span>
                            {singleCate.title}
                          </Typography>
                        </div>
                      </AccordionSummary>

                      <AccordionDetails>
                      <div className="cardWrapper">
                        {this.state.loadingProducts ? (
                          <div
                            style={{ textAlign: "center", marginTop: "80px" }}
                          >
                            <CircularProgress />
                          </div>
                        ) : (
                          <Grid container spacing={3}>
                            {this.state["products" + index]
                              ? this.state["products" + index].map(
                                  (ele, ind) => (
                                    <Grid item sm={3} key={ind}>
                                      <ProductCard
                                        imgSrc={
                                          ele.poster_image_url
                                            ? API.imgUrl + ele.poster_image_url
                                            : modelImg1
                                        }
                                        id={ele._id}
                                        title={ele.title}
                                        views={ele.views}
                                      />
                                    </Grid>
                                  )
                                )
                              : null}
                          </Grid>
                        )}
                      </div>
                    </AccordionDetails>
                
                    </Accordion>
                  ))}
                </div>
              ) : null} */}
            </div>
          </Grid>
        </Grid>
      </Container>
    );
  }
}
